


import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IoMdCheckmarkCircleOutline } from 'react-icons/io'

const Success = ({ show, close, message }) => {
    return (
        <Modal show={show} onHide={close}>
            <Modal.Header className="gap-2 border-none">
                <IoMdCheckmarkCircleOutline
                    color="#039855"
                    className="successIcon"
                    size={30}
                />
                <div>
                    <Modal.Title className="titletext">Success!</Modal.Title>
                    <p className="textsubtitle">
                        {message}
                    </p>
                </div>
            </Modal.Header>
            <Modal.Footer className='border-none'>
                <Button className="btnUndo" onClick={close}>
                    Undo
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default Success
